<template>
  <v-container fluid style="height:100%" pa-0 ma-0>
    <v-row no-gutters align="center" justify="center" style="background-color:#F26539;">
      <v-col cols="2" class="pr-2" v-if="selectedFilesTab === 'logos' || selectedFilesTab === 'drafts'">
        <v-autocomplete
          v-model="selectedCompanyId"
          :items="getCompanies"
          label="Suodata yrityksellä"
          item-text="text"
          item-value="value"
          dark
          style="background:#F26539"
          chips
        >
          <template v-slot:selection="data">
            <v-chip
              :input-value="data.selected"
              close
              small
              solo
              class="chip--select-multi"
              @click:close="selectedCompanyId = ''"
            >
              {{ data.item.text.substr(0,20) }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="ml-6" v-if="selectedFilesTab === 'productImages' || selectedFilesTab === 'drafts'">
        <v-autocomplete
          v-model="selectedProductId"
          :items="getProducts"
          label="Suodata tuotteelle"
          item-text="text"
          item-value="value"
          class="red-caret"
          dark
          chips
        >
          <template v-slot:selection="data">
            <v-chip
              :input-value="data.selected"
              close
              small
              class="chip--select-multi"
              @click:close="selectedProductId = ''"
            >
              {{ data.item.text.substr(0,20) }}
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="ml-6" v-if="selectedFilesTab === 'chainDrafts' || selectedFilesTab === 'productImages'">
      </v-col>
    </v-row>
    <v-tabs
      fixed-tabs
      dark
      dense
      height="35"
      v-model="selectedFilesTab"
      background-color="#F26539"
    >
      <v-tabs-slider color="#FFF"></v-tabs-slider>
      <v-tab href="#logos" >Asiakkaiden logot</v-tab>
      <v-tab href="#drafts">Asiakkaiden vedokset</v-tab>
      <v-tab href="#chainLogos">Ketjuasiakkeiden logot</v-tab>
      <v-tab href="#chainDrafts">Ketjuasiakkeiden vedokset</v-tab>
      <v-tab href="#productImages">Tuotekuvat</v-tab>
      <!--<v-tab href="#promotionLists">Listat</v-tab>-->
      <v-tab-item value="logos">
         <MediaGrid :types="['logo']" :actions="['copyUrl','download']" colsPerItem="1" :filterCompanyId="selectedCompanyId" :filterUserId="staff[user.uid].role === 'sales' && !staff[user.uid].isAdmin ? user.uid : ''"></MediaGrid>
      </v-tab-item>
      <v-tab-item value="drafts">
        <MediaGrid :types="['draft']" :actions="['copyUrl','download']" colsPerItem="1" :filterCompanyId="selectedCompanyId" :filterProductId="selectedProductId" :filterUserId="staff[user.uid].role === 'sales' && !staff[user.uid].isAdmin ? user.uid : ''"></MediaGrid>
      </v-tab-item>
      <v-tab-item value="chainLogos">
        <MediaGrid :types="['logo']" :actions="['copyUrl','download']" colsPerItem="1" :sharedLogosOnly="true" :filterCompanyId="selectedCompanyId" :filterProductId="selectedProductId" :filterUserId="staff[user.uid].role === 'sales' && !staff[user.uid].isAdmin ? user.uid : ''"></MediaGrid>
      </v-tab-item>
      <v-tab-item value="chainDrafts">
        <MediaGrid :types="['draft']" :actions="['copyUrl','download']" colsPerItem="1" :sharedDraftsOnly="true" :filterCompanyId="selectedCompanyId" :filterProductId="selectedProductId" :filterUserId="staff[user.uid].role === 'sales' && !staff[user.uid].isAdmin ? user.uid : ''"></MediaGrid>
      </v-tab-item>
      <v-tab-item value="productImages">
        <MediaGrid :types="['productImage']" :actions="['copyUrl','download']" colsPerItem="1" :filterProductId="selectedProductId" ></MediaGrid>
      </v-tab-item>
    </v-tabs>    
  </v-container>  
</template>
<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'

export default {
    data () {
      return {
        selectedCompanyId:"",
        selectedProductId:"",
        isActive:false,
        selectedFilesTab:'logos',
        autogrow:true,
        clipped: false,
        email: '',
        password: '',
        passwordConfirm: '',
        isTopBarFlat:true,
        clipped: true,
        clippedToolbar:true,
        alert: false,
        right: true,
        hideSlider:true,
        miniVariant: true,
        rightDrawer: true,
      }
    },
    mounted() {
      
    },
    computed: {
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      getProducts(){
        var products = this.products
        return Object.keys(this.products).reduce(function(result, key) {
          var p = products[key]
          if (p.name !== undefined && p.name.fi !== undefined) {
            result.push({text: p.name.fi, value: p.id});
          }
          else {
            console.log(p)
          }
          return result;
        }, []);
      },
      ...mapFields({
        companies:'company.companies',
        products:'product.products',
        staff:'staff.staff',
        user:"user",
      }),
    },
    created () {},
    methods: {
      
      example(message) {
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/Files.vue